(function () {
  'use strict';

  function initParallax() {
    var section = document.getElementById('shopify-section-kaay_brand_story');
    if (!section) return;

    var mediaBlock = section.querySelector('.media-block');
    if (!mediaBlock) return;

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Desktop only
    if (window.matchMedia('(max-width: 749px)').matches) return;

    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight;

      // Only animate when section is in/near viewport
      if (rect.bottom < -vh || rect.top > vh * 2) {
        ticking = false;
        return;
      }

      // Progress: 0 when section top hits viewport bottom, moves negative as we scroll down
      var scrolled = -rect.top;

      // Image: slow drift upward (feels heavier, behind)
      var imgY = scrolled * 0.10;

      // Sun: faster drift (feels lighter, in front)
      var sunY = scrolled * 0.25;

      mediaBlock.style.setProperty('--parallax-img', imgY + 'px');
      mediaBlock.style.setProperty('--parallax-sun', sunY + 'px');

      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
